import { getLocale } from "../runtime";

const sv_reviews = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Recensioner`
};

const reviews = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_reviews(inputs)
	return "reviews";
};

export { reviews as "reviews" };